export function getCurrentFullScreenElement() {
    return (document.fullscreenElement
        || document.webkitFullscreenElement
        || document.webkitFullScreenElement
        || document.mozFullScreenElement
        || document.msFullscreenElement);
}
export function enterFullScreen(videoElement) {
    if (!videoElement) {
        return;
    }
    var elem = videoElement;
    var fn = videoElement.requestFullscreen
        || elem.mozRequestFullScreen
        || elem.webkitRequestFullscreen
        || elem.webkitRequestFullScreen
        || elem.msRequestFullscreen
        || elem.webkitEnterFullscreen
        || elem.webkitEnterFullScreen;
    if (!fn) {
        elem = document;
        fn = elem.requestFullscreen
            || elem.mozRequestFullScreen
            || elem.webkitRequestFullscreen
            || elem.webkitRequestFullScreen
            || elem.msRequestFullscreen
            || elem.webkitEnterFullscreen
            || elem.webkitEnterFullScreen;
    }
    if (fn) {
        fn.call(elem);
        return true;
    }
    return false;
}
export function exitFullScreen(videoElement) {
    if (!videoElement) {
        return;
    }
    var elem = videoElement;
    var fn = elem.cancelFullScreen
        || elem.mozCancelFullScreen
        || elem.webkitCancelFullScreen
        || elem.exitFullscreen
        || elem.webkitExitFullscreen
        || elem.webkitExitFullScreen
        || elem.msExitFullscreen;
    if (!fn) {
        elem = document;
        fn = elem.cancelFullScreen
            || elem.mozCancelFullScreen
            || elem.webkitCancelFullScreen
            || elem.exitFullscreen
            || elem.webkitExitFullscreen
            || elem.webkitExitFullScreen
            || elem.msExitFullscreen;
    }
    if (fn) {
        fn.call(elem);
        return true;
    }
    return false;
}
